import { Component, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { ToastService } from '../../services/toast.service';
import { AppConstants } from '../../utilities/constant';

@Component({
  selector: 'app-project-access',
  templateUrl: './project-access.component.html',
  styleUrls: ['./project-access.component.scss'],
})
export class ProjectAccessComponent implements OnInit {

  constructor(
    public modalController: ModalController,
    public toastController: ToastController,
    public sharedValue: ShareValuesService,
    private toastService: ToastService,
    private translate: TranslateService
  ) { }

  ngOnInit() { }

  close() {
    const _self = this;
    _self.modalController.dismiss({
      dismissed: true,
    });
  }

  dismissModal() {
    const _self = this;
    _self.modalController.dismiss({
      dismissed: true,
    });
    this.toastService.presentToast(this.translate.instant('request_sent_successfully'), 4000, AppConstants.SUCCESS_SNACKBAR, 'top');
  }

}
